export const getTizenVersion = (): string => {
  const ua = window.navigator.userAgent
  const match = /Tizen (\d\.\d)/.exec(window.navigator.userAgent)
  return match ? match[1] : 'unknown'
}
